<template>
  <page-edicion fluid>
    <page-header :title="oferta.descripcion" subtitle="Contenido de la oferta" @back="volver" />
    <b-form class="formularioContenido" @submit.prevent="guardar">
      <b-card no-body>
        <b-tabs pills card>
          <b-tab title="Carta de presentación" active>
            <b-form-group>
              <wysiwyg v-model="ofertaContenido.texto" placeholder="Escriba aquí" />
            </b-form-group>
          </b-tab>
          <b-tab title="Necesidades">
            <b-form-group>
              <wysiwyg v-model="ofertaContenido.necesidades" placeholder="Escriba aquí" />
            </b-form-group>
          </b-tab>
          <b-tab title="Resumen Ejecutivo">
            <b-form-group>
              <wysiwyg v-model="ofertaContenido.resumenEjecutivo" placeholder="Escriba aquí" />
            </b-form-group>
          </b-tab>
          <b-tab title="Aclaraciones">
            <b-form-group>
              <wysiwyg v-model="ofertaContenido.aclaraciones" placeholder="Escriba aquí" />
            </b-form-group>
          </b-tab>

          <b-tab title="Logos">
            <b-form-group>
              <wysiwyg v-model="ofertaContenido.logosClientes" />
            </b-form-group>
          </b-tab>

          <b-tab title="Anexo">
            <b-form-group>
              <wysiwyg v-model="ofertaContenido.anexo" placeholder="Escriba aquí" />
            </b-form-group>
          </b-tab>
          <b-tab title="Beneficios">
            <b-form-group>
              <wysiwyg v-model="ofertaContenido.beneficios" placeholder="Escriba aquí" />
            </b-form-group>
          </b-tab>
          <b-tab title="Usuarios">
            <b-form-group>
              <wysiwyg v-model="ofertaContenido.usuarios" placeholder="Escriba aquí" />
            </b-form-group>
          </b-tab>
          <b-tab title="Plan de soporte">
            <b-form-group>
              <wysiwyg v-model="ofertaContenido.planDeSoporte" placeholder="Escriba aquí" />
            </b-form-group>
          </b-tab>
          <b-tab title="Requisitos mínimos">
            <b-form-group>
              <wysiwyg v-model="ofertaContenido.requisitosMinimos" placeholder="Escriba aquí" />
            </b-form-group>
          </b-tab>
        </b-tabs>
      </b-card>

      <botonera-edicion @cancelar="volver" />
    </b-form>
  </page-edicion>
</template>

<script>
import * as ofertasApi from "@/services/ofertas";

export default {
  data() {
    return {
      oferta: {},
      ofertaContenido: {},
    };
  },
  async mounted() {
    const id = this.$route.params.id;
    this.oferta = await ofertasApi.cargar(id);
    this.ofertaContenido = await ofertasApi.cargarContenidoVersion(id);
  },
  methods: {
    volver() {
      this.$router.push(`/ofertas/editar/${this.oferta.id}`);
    },
    async guardar() {
      await ofertasApi.guardarContenidoVersion(this.ofertaContenido);
      this.volver();
    },
  },
};
</script>
